import React, { useContext,useState, useEffect } from 'react';
import { globalContext,LayoutContext } from '_context/LayoutContext';
import { MapContext } from '_context/MapContext';

import Search from 'pages/SEARCH';
import RP from 'pages/RP';
import Top from 'pages/TOP';
import LNB from 'pages/LNB';
import SIMUL from 'pages/SIMUL';

import KTMap from 'component/KTMap'

const Map = (props) => {

  const { poi,selectedId,selectedPoi,opts,routes,rpOpts,setRPOpts,selectedTbt, poiResult, setPoiResult, setThisPoint } = useContext(MapContext);
  const { currentLocation } = useContext(globalContext);

  useEffect(() => {
    // if(Object.keys(poi).length > 1){
    //   poiSearchClick();
    // }
    poiSearchClick();
  }, [poi]);

  function poiSearchClick(e){
    setPoiResult(JSON.parse(JSON.stringify(poi)))
  }

  function poiClickHandler(e, id){
   selectedPoi(id)
  }

  function tbtClickHandler(e, id){
    setRPOpts("selectedTbt",id)
   }

  function thisPointAddressHandler(placeAdddres, roadAddress, latLngPoint, utmkPoint){
    alert('이 위치 주소보기 : ' + placeAdddres.fullAddress)
  }

  function thisPointResearchHandler(placeAdddres, roadAddress, latLngPoint, utmkPoint){
    //alert('이 위치 재검색 : ' + placeAdddres.fullAddress)
    setThisPoint(utmkPoint)
  }

  return (
    <KTMap poiClick={poiClickHandler} tbtClick={tbtClickHandler}thisPointAddressHandler={thisPointAddressHandler}thisPointResearchHandler={thisPointResearchHandler}/>
  )
}

const MainView = () => {
  const { status } = useContext(LayoutContext);
 
  return (
    <div>
      <Map /> 
      {/* {status==="search"? <Search /> : <RP />} */}
      <Search />
      <RP/>
      <LNB />
      <SIMUL />
      <Top /> 
    </div>
  );
}

export default MainView;